import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './index.css';

function RegisterSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/register');
  };

  return (
    <div className="reg-success-page">
      <div className="reg-success-bg" aria-hidden="true" />
      <div className="reg-success-card">
        <div className="reg-success-icon-wrap">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 80 80"
            fill="none"
          >
            <circle cx="40" cy="40" r="40" fill="#EFFFDC" />
            <path
              d="M56.1141 40.0262C56.1141 30.9228 48.9004 23.5431 40.0019 23.5431C31.1033 23.5431 23.8896 30.9228 23.8896 40.0262C23.8896 49.1296 31.1033 56.5093 40.0019 56.5093C48.9004 56.5093 56.1141 49.1296 56.1141 40.0262ZM60.7176 40.0262C60.7176 51.7305 51.4429 61.2188 40.0019 61.2188C28.5609 61.2188 19.2861 51.7305 19.2861 40.0262C19.2861 28.3219 28.5609 18.8336 40.0019 18.8336C51.4429 18.8336 60.7176 28.3219 60.7176 40.0262Z"
              fill="#86BB00"
            />
            <path
              d="M46.2709 32.9796C47.1698 32.0604 48.6269 32.0602 49.5257 32.9796C50.4242 33.8991 50.4242 35.3899 49.5257 36.3094L39.0015 47.0758C38.1026 47.9936 36.6451 47.9945 35.7467 47.0758L30.4868 41.6903C29.5886 40.7707 29.5882 39.2799 30.4868 38.3606C31.3856 37.4418 32.8429 37.4418 33.7417 38.3606L37.3741 42.0766L46.2709 32.9796Z"
              fill="#86BB00"
            />
          </svg>
        </div>
        <h2 className="reg-success-title">{t('register.success.title')}</h2>
        <p className="reg-success-desc">{t('register.success.pageDesc')}</p>
        <button type="button" className="reg-success-btn" onClick={handleBack}>
          {t('register.success.btn')}
        </button>
      </div>
    </div>
  );
}

export default RegisterSuccess;
